// src/data/newsArticles.js
import dummyImage1 from '../images/The-Importance-of-Regular-Exercise-for-Mental-Health.jpg';
import dummyImage2 from '../images/5-Superfoods-to-Boost-Your-Immune-System-This-Spring.jpg';
import dummyImage3 from '../images/Breakthrough-in-Non-Invasive-Cancer-Detection.jpg';
import dummyImage4 from '../images/Local-Initiative-Promotes-Healthy-Eating-Habits.jpg';
import dummyImage5 from '../images/Understanding-the-Risks-and-Prevention-of-Digital-Eye-Strain.jpg';
import dummyImage6 from '../images/Managing-Allergy-Symptoms-During-Pollen-Season.jpg';

const newsArticles = [
  {
    imageUrl: dummyImage1,
    category: 'Wellness',
    date: 'April 20, 2025',
    title: 'The Importance of Regular Exercise for Mental Health',
    description: 'Discover how incorporating regular physical activity into your routine can significantly improve your mental well-being and reduce stress levels.',
    detailsLink: '/news/exercise-mental-health',
  },
  {
    imageUrl: dummyImage2,
    category: 'Nutrition',
    date: 'April 18, 2025',
    title: '5 Superfoods to Boost Your Immune System This Spring',
    description: 'Learn about five nutrient-rich foods that can help strengthen your immune system and keep you healthy during the spring season.',
    detailsLink: '/news/immune-boosting-foods',
  },
  {
    imageUrl: dummyImage3,
    category: 'Medical Advances',
    date: 'April 15, 2025',
    title: 'Breakthrough in Non-Invasive Cancer Detection',
    description: 'Read about the latest advancements in medical technology that allow for earlier and less invasive detection of certain types of cancer.',
    detailsLink: '/news/cancer-detection-breakthrough',
  },
  {
    imageUrl: dummyImage4,
    category: 'Community Health',
    date: 'April 12, 2025',
    title: 'Local Initiative Promotes Healthy Eating Habits',
    description: 'Find out about a new community program focused on educating residents about the benefits of healthy eating and providing access to fresh produce.',
    detailsLink: '/news/community-healthy-eating',
  },
  {
    imageUrl: dummyImage5,
    category: 'Ophthalmology',
    date: 'April 09, 2025',
    title: 'Understanding the Risks and Prevention of Digital Eye Strain',
    description: 'With increased screen time, it\'s crucial to understand the causes and learn effective strategies to prevent digital eye strain.',
    detailsLink: '/news/digital-eye-strain',
  },
  {
    imageUrl: dummyImage6,
    category: 'Respiratory Health',
    date: 'April 05, 2025',
    title: 'Managing Allergy Symptoms During Pollen Season',
    description: 'Get practical tips and advice on how to effectively manage your allergy symptoms as pollen levels rise during the spring.',
    detailsLink: '/news/allergy-symptom-management',
  },
  // Add more news articles here
];

export default newsArticles;